<template>
  <div>
    <section class="section-1 position-relative d-flex flex-column justify-content-start align-items-center h-auto min-vh-100 w-100">
      <div class="embed-responsive embed-responsive-16by9">
        <div class="embed-responsive-item bg-dark header-bg"></div>
      </div>

      <div class="py-5" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="content w-100" v-else>
        <div class="container mt-5 pb-5">
          <div class="row" v-for="event in events" :key="event.id">
            <div class="col-12 pb-3">
              <event-player :event="event"></event-player>
            </div>
            <div class="col-12 col-md-6" v-if="event.qnaEnabled">
              <event-qna :event="event"></event-qna>
            </div>
            <div class="col-12 col-md-6">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  // import EventImage from "@/components/event-image.vue"
  import EventQna from "@/components/event-qna.vue"
  import EventPlayer from '../components/event-player.vue'

  export default {
    name: "home",
    // components: { EventImage, EventQna, EventPlayer },
    components: { EventQna, EventPlayer },
    data() {
      return {
        loading: true,
        sending: false,
        events: []
      }
    },
    async mounted() {
      let eventsRef = await firebase.firestore().collection(`events`).where("active", "==", true).orderBy("eventStart")
      let events = await eventsRef.get()
      this.events = events.docs.map((doc) => {
        return Object.assign({}, { id: doc.id }, doc.data())
      })

      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  .header-bg {
    background-image: url('../assets/images/header-image.jpg');
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>